import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { getAndFormatDateFromString } from '@/condor/ui/common/Layout/helpers';
import { MONTH_DAY_YEAR_FORMAT as formatString } from '@dealroadshow/uikit-date-time/dateFormats';
import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/DateList/dateList.module.scss';

export const DateList = ({ row: deal }: ICellProps) => {
  const { pricingDate, announcedDate, lastUpdated, settlementDate, roadshowDates } = deal;

  const tooltip = (
    <div className={ styles.tooltip }>
      <div>
        <span>Announced</span>
        <span>
          { getAndFormatDateFromString(announcedDate?.dateTime, { timeZone: announcedDate?.timezone, formatString }) }
        </span>
      </div>
      <div>
        <span>Pricing</span>
        <span>
          { getAndFormatDateFromString(pricingDate?.dateTime, { timeZone: pricingDate?.timezone, formatString }) }
        </span>
      </div>
      <div>
        <span>Settlement</span>
        <span>
          { getAndFormatDateFromString(settlementDate?.dateTime, { timeZone: settlementDate?.timezone, formatString }) }
        </span>
      </div>
      <div>
        <span>Roadshow Dates</span>
        <span>{ roadshowDates }</span>
      </div>
      <div>
        <span>Last Updated</span>
        <span>
          { getAndFormatDateFromString(lastUpdated?.dateTime, { timeZone: lastUpdated?.timezone, formatString }) }
        </span>
      </div>
    </div>
  );

  return (
    <div data-test="dealRowDates">
      { !!pricingDate && (
      <Tooltip content={ tooltip }>
        { getAndFormatDateFromString(pricingDate?.dateTime, { timeZone: pricingDate?.timezone, formatString }) }
      </Tooltip>
      ) }

      { !pricingDate && announcedDate && (
        <Tooltip content={ tooltip }>
          { getAndFormatDateFromString(announcedDate?.dateTime, { timeZone: announcedDate?.timezone, formatString }) }
        </Tooltip>
      ) }
    </div>
  );
};
